import React from 'react'
import styled from 'styled-components'

type ScreenProps = React.HTMLAttributes<HTMLDivElement>

const Screen_: React.FC<ScreenProps> = ({ children, ...props }) => {
  return <Root {...props}>{children}</Root>
}

const Root = styled.div`
  background: var(--mobile-background);
  position: relative;
  height: var(--viewport-height);
  padding-top: var(--safe-top);
`

const ActionContainer = styled.div`
  padding-block: 0 var(--safe-bottom);
  padding-inline: 12px;
`

type Compound = typeof Screen_ & {
  ActionContainer: typeof ActionContainer
}

const Screen = Screen_ as Compound
Screen.ActionContainer = ActionContainer
export { Screen }
